import { Button, CircularProgress } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { FinancialExportStyles } from "./styles";
import { DownloadButtonProps } from "./type";

const DownloadButton = ({ onClick, loading = false }: DownloadButtonProps) => {
  return (
    <Button
      startIcon={
        loading ? (
          <CircularProgress size={16} />
        ) : (
          <FileDownloadOutlinedIcon sx={FinancialExportStyles.downloadIcon} />
        )
      }
      variant="outlined"
      sx={FinancialExportStyles.downloadButton}
      size="small"
      onClick={onClick}
      disabled={loading}
    >
      {"DOWNLOAD"}
    </Button>
  );
};

export default DownloadButton;
